module.exports = __webpack_public_path__ + "img/blueBell.3aadc2e3.svg";